import React from 'react';
import cn from 'classnames';

import {useContentCardContext} from '../../ContentCard';

import {IContentCardInnerWrapperProps} from './IContentCardInnerWrapper';

import styles from './ContentCardInnerWrapper.module.scss';

const ContentCardInnerWrapper = (props: IContentCardInnerWrapperProps) => {
	const {style} = useContentCardContext();

	return (
		<div
			className={cn(
				styles['content-card__inner-wrapper'],
				'content-card__inner-wrapper',
				{
					[styles[`content-card__inner-wrapper--${style}`]]: style,
				}
			)}
		>
			{props.children}
		</div>
	);
};

export default ContentCardInnerWrapper;
